(function() {
  var path = window.location.pathname.toLowerCase();

  var redirects = {
  "/products/sleepee-bundles": "/products/sleepee",
  "/products/calmee-bundle": "/products/calmee",
  "/products/creatine-bundle": "/products/creatine",
  "/products/multee-bundle": "/products/multee",
  "/products/reeplay-bundles": "/products/reeplay",
  "/products/vit-d3-bundle": "/products/vitamin-d3",
  "/products/flowee-bundles": "/products/flowee",
  "/products/sleep-starter-plan": "/products/sleepee",
  "/products/health-starter-plan": "/products/multee",
  "/products/hydree-trial-pack": "/products/hydree",
  "/products/hydree-bundle": "/products/hydree",
  "/products/utee-protect": "/products/utee",
  "/products/utee-clear": "/products/utee"
  };

  if (redirects[path]) {
    var target = redirects[path] + window.location.search; // keeps ?utm / ?discount / ?ref
    window.location.replace(target);
  }
})();